'use client'

import React, { createContext, useContext, useEffect, useState } from 'react'
import {
  storeTokens, clearTokens, getAccessTokenFromStorage, getRefreshTokenFromStorage,
  revokeRefreshToken
} from '../utils/tokenService.ts'

interface AuthContextType {
  isAuthenticated: boolean;
  login: (access: string, refresh: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  login: () => { },
  logout: () => { }
})

export function useAuth() {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAthenticated] = useState<boolean>(false)

  useEffect(() => {
    const access = getAccessTokenFromStorage()
    const refresh = getRefreshTokenFromStorage()

    setIsAthenticated(!!access && !!refresh)
  }, [])

  const login = (access: string, refresh: string) => {
    storeTokens(access, refresh)
    setIsAthenticated(true)
  }

  const logout = () => {
    // Fire-and-forget: revoke the refresh token server-side so a captured token
    // cannot outlive the session. Local state is cleared immediately either way.
    void revokeRefreshToken()
    clearTokens()
    setIsAthenticated(false)
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}
